module.exports = __webpack_public_path__ + "img/logo.5df19ad3.png";